import { API_V3_BASE_URL, type BrandingAssetType } from "@/api-v3";

/**
 * Builds the URL for a tenant branding asset, always routed through the API
 * (`/branding/asset/{type}`), which 302-redirects to the CDN with a cacheable
 * response. We never embed direct CDN URLs in the app: the tenant is resolved
 * by the backend from the request domain, so the same URL serves every tenant.
 */
export const brandingAssetUrl = (assetType: BrandingAssetType): string =>
  `${API_V3_BASE_URL}/branding/asset/${assetType}`;
